var path = 'directives/refineDataviews/refineDataviews.html';
var html = "<sidebar-block-header name=\"Data View\" view=\"{{ vm.activeTab }}\"></sidebar-block-header><div class=check-boxes><fieldset class=\"fieldset dataview-select\"><p ng-repeat=\"view in vm.dataviews\"><input type=radio name=radio-select ng-value=$index id=\"dataview-cb-{{ $index }}\" ng-model=vm.dataView ng-change=vm.updateDataview($index)><label for=\"dataview-cb-{{ $index }}\">{{ view.label }}</label></p></fieldset></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./js/directives/refineDataviews/refineDataviews.html
 ** module id = 177
 ** module chunks = 0
 **/